export default process.env.VUE_APP_WS_HOST === 'ws.app.reskript.local' ? 'ws' : 'wss';
